import React, { useContext } from 'react';
import { IonButtons, IonButton, IonIcon, NavContext } from '@ionic/react';
import store from '../../store';

export default () => {
  const { navigate } = useContext(NavContext);

  function handleClick () {
    const id = store.getState().currentProject.id;
    navigate(`/projects/${id}`, 'back');
  }

  return (
    <IonButtons slot="start">
      <IonButton onClick={() => handleClick()}>
        <IonIcon name="arrow-back" />
      </IonButton>
    </IonButtons>
  );
};
